module.exports = __webpack_public_path__ + "img/電気回路_2_7_3.5e70939d.png";